// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Select,
//   Typography,
//   Grid as MuiGrid,
//   Pagination,
//   Button,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import { useNavigate } from 'react-router';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import SearchImg from '../../assets/search.svg';
// import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
// import BigFilter from 'src/components/inputs/BigFilter';
// import { ClearIcon } from '@mui/x-date-pickers-pro';
// import { MdDelete } from "react-icons/md";

// export const TrimData = (data) => {
//   if (data?.length < 25) return data;
//   return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
// };

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };

// const AllDraftBills = () => {
//   const [draftBilldata, setDraftBillData] = useState([]);
//   const [showLoader, setShowLoader] = useState(false);
//   const [loadingBillId, setLoadingBillId] = useState(null);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [search, setSearch] = useState('');
//   const [genderBy, setGenderBy] = useState([]);
//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(1);
//   const [clear, setClear] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [filterData, setFilterData] = useState([]);
//   const [filteredDataCount, setFilteredDataCount] = useState(0);

//   const { activeBranchId, fetchDraftBill, fetchSingleBill, setShowMessage, branchData, deleteDraftBill } = useMain();
//   const navigate = useNavigate();
//   console.log(draftBilldata,'draftBilldata')
//   const filterGenderWise = [
//     { value: 'Female', label: 'Female' },
//     { value: 'Male', label: 'Male' },
//   ];

//   const handleRowClick = async (billData) => {
//     if (billData && billData._id) {
//       try {
//         setLoadingBillId(billData._id);
//         const queryParams = `?branchId=${activeBranchId}&billId=${billData._id}&draftBillId=${billData?.draftBillId}`;
//         const res = await fetchSingleBill(queryParams);

//         if (res?.statusCode === 200 || res?.status === 'success') {
//           const singleBill = res?.data || [];
//           console.log(singleBill,'singleBill')
//           navigate('/addbilling', { state: { draftBill: singleBill } });
//         } else {
//           console.error('Failed to fetch single bill data');
//         }
//       } catch (error) {
//         console.error('Error fetching single draft bill:', error);
//       } finally {
//         setLoadingBillId(null);
//       }
//     } else {
//       console.error('Invalid bill data:', billData);
//     }
//   };

//   const getDraftBillsData = async (queryParams = '') => {
//     try {
//       setShowLoader(true);
//       const params = queryParams || '?page=1';
//       const res = await fetchDraftBill(activeBranchId, params);

//       if (res?.statusCode === 200 || res?.status === 'success') {
//         setDraftBillData(res?.data || []);
//         if (!queryParams.includes('startDate') && !queryParams.includes('endDate')) {
//           setFilteredDataCount(res?.data?.length || 0);
//         }
//       } else {
//         setDraftBillData([]);
//       }
//     } catch (error) {
//       setDraftBillData([]);
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getDraftBillsData();
//     }
//   }, [activeBranchId]);

//   useEffect(() => {
//     applyFilters(draftBilldata, limit, genderBy, page, search, startDate, endDate);
//   }, [draftBilldata, limit, genderBy, page, search, startDate, endDate]);

//   const applyFilters = (data, limit, gender, page, search, startDate, endDate) => {
//     let filteredData = [...data];

//     filteredData = filteredData.filter((item) => {
//       let isGenderMatch = true;
//       let isNameMatch = true;

//       if (gender.length) {
//         isGenderMatch = genderBy.includes(item.gender);
//       }

//       if (search) {
//         isNameMatch =
//           item.clientName.toLowerCase().includes(search.toLowerCase()) ||
//           item.clientNumber.includes(search);
//       }

//       if (startDate && endDate) {
//         const itemDate = new Date(item.dateOfBilling);
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         isNameMatch = isNameMatch && itemDate >= start && itemDate <= end;
//       }

//       return isGenderMatch && isNameMatch;
//     });

//     setFilteredDataCount(filteredData.length);

//     const startIndex = (page - 1) * limit;
//     const endIndex = startIndex + limit;
//     const paginatedData = filteredData.slice(startIndex, endIndex);

//     setFilterData(paginatedData);
//   };

//   const handleDateRangeSelected = (start, end) => {
//     setStartDate(start);
//     setEndDate(end);
//     setIsModalOpen(false);
//     const queryParams = `?page=${page}${genderBy ? `&gender=${genderBy}` : ''}${search ? `&search=${search}` : ''
//       }${start ? `&startDate=${start}` : ''}${end ? `&endDate=${end}` : ''}`;
//     getDraftBillsData(queryParams);
//     setClear(true);
//   };

//   const handleLimitChange = (e) => {
//     setLimit(e.target.value);
//     setPage(1);
//   };

//   const handlePageChange = (e, value) => {
//     setPage(value);
//   };

//   const confirmDeleteDraftBill = async () => {
//     setShowLoader(true);
//     try {
//       const res = await deleteDraftBill(deleteId, activeBranchId);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Draft bill deleted successfully',
//           messageType: 'success',
//         });
//         setDraftBillData(draftBilldata?.filter((d) => d?._id !== deleteId));
//         await getDraftBillsData();
//       } else {
//         setShowMessage({
//           message: res.message || 'Draft bill not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//       setShowLoader(false);
//     }
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <>
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
//         <div
//           style={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             alignItems: 'center',
//             marginBottom: '1.5rem',
//           }}
//         >
//           {/* Left Side: Show per page and Choose Date */}
//           <div
//             style={{
//               display: 'flex',
//               flexDirection: 'row',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               flex: '1 1 300px',
//             }}
//           >
//             <div style={{ flex: '1 1 150px', maxWidth: '500px' }}>
//               <InputLabel>Show per page</InputLabel>
//               <Select
//                 style={{
//                   borderRadius: '7px',
//                   border: '0.5px solid #6174DD',
//                   padding: '4px 12px',
//                   background: '#FFF',
//                   height: '40px',
//                 }}
//                 value={limit}
//                 onChange={handleLimitChange}
//               >
//                 {[10, 20, 50].map((value) => (
//                   <MenuItem key={value} value={value}>
//                     {value}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </div>

//             <div style={{
//               flex: '1 1 150px', marginLeft: '-16rem',
//               marginTop: '1.9rem'
//             }}>
//               <Button
//                 variant="outlined"
//                 sx={{
//                   color: 'black',
//                   height: '40px',
//                   width: startDate && endDate ? '60%' : '40%',
//                   display: 'flex',
//                   justifyContent: startDate && endDate ? 'space-between' : 'center',
//                   padding: '0 8px',
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                 }}
//                 onClick={openModal}
//               >
//                 {startDate && endDate ? (
//                   <>
//                     <span>{`${startDate} to ${endDate}`}</span>
//                     <IconButton
//                       size="small"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setStartDate('');
//                         setEndDate('');
//                         setPage(1);
//                         getDraftBillsData('?page=1');
//                       }}
//                       sx={{
//                         padding: 0,
//                         '&:hover': {
//                           backgroundColor: 'transparent',
//                         },
//                       }}
//                     >
//                       <ClearIcon style={{ color: '#000', height: '1rem' }} />
//                     </IconButton>
//                   </>
//                 ) : (
//                   'Choose Date'
//                 )}
//               </Button>
//             </div>
//           </div>
//         </div>

//         {/* Right Side: Filters and Search */}
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '1.4rem',
//           marginLeft: '15rem'
//         }}>
//           <div style={{ width: '60%', marginRight: '-4rem', marginTop: '13px' }}>
//             <BigFilter
//               options={[
//                 { title: 'Gender', items: filterGenderWise }
//               ]}
//               value={[...genderBy]}
//               onChange={(selectedValues) => {
//                 setGenderBy(selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val)));
//               }}
//               placeholder="Filters"
//             />
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8rem' }} onClick={() => document.getElementById('search-input').focus()}>
//             <InputLabel style={{ display: 'flex', flexDirection: 'column' }}>Search</InputLabel>
//             <div className="search-input" style={{ display: 'flex', alignItems: 'center' }}>
//               <img src={SearchImg} alt="search icon" style={{ marginRight: '8px' }} />
//               <input
//                 id="search-input"
//                 type="text"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 style={{ border: 'none', outline: 'none', flex: 1 }}
//               />
//               {search && (
//                 <IconButton
//                   onClick={() => {
//                     setSearch('');
//                     setClear(false);
//                   }}
//                   style={{ padding: 1 }}
//                 >
//                   <ClearIcon style={{
//                     color: '#000',
//                     marginRight: '-0.2rem', marginTop: '0.1rem',
//                     fontSize: '1.1rem'
//                   }} />
//                 </IconButton>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {showLoader ? (
//         <ShowLoader />
//       ) : filterData.length > 0 ? (
//         <Box>
//           <MuiGrid container spacing={3}>
//             <MuiGrid item xs={12}>
//               <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' }}}>
//                 <table className="table-container mt-3">
//                   <thead className="table-thead">
//                     <tr>
//                       {['Date of Bill', 'Client Name', 'Contact', 'Gender', 'Add', 'Action'].map((h, index) => (
//                         <th key={index} style={{ width: '100%' }}>
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody className="table-tbody">
//                     {filterData.map((item) => {
//                       const originalDate = item?.dateOfBilling;

//                       let formattedBillDate = '';
//                       if (originalDate) {
//                         const [year, month, day] = originalDate.split('-');
//                         formattedBillDate = `${day}-${month}-${year}`;
//                       }

//                       return (
//                         <tr key={item._id}>
//                           <td style={{ width: '100%' }}>{formattedBillDate}</td>
//                           <td style={{ width: '100%' }}>{item?.clientName}</td>
//                           <td style={{ width: '100%' }}>
//                             {maskData(item?.clientNumber, branchData?.isMasked)}
//                           </td>
//                           <td style={{ width: '100%' }}>{item?.gender}</td>
//                           <td style={{ width: '120%' }}>
//                             <Button
//                               style={{
//                                 backgroundColor: '#5d87ff',
//                                 color: 'white',
//                                 fontSize: '14px',
//                                 fontWeight: 'bold',
//                                 width: '120px',
//                                 height: '40px',
//                                 '&:hover': {
//                                   backgroundColor: '#6174DD',
//                                 },
//                               }}
//                               onClick={() => handleRowClick(item)}
//                             >
//                               {loadingBillId === item._id ? (
//                                 <CircularProgress size={24} style={{ color: '#03C4A9' }} />
//                               ) : (
//                                 'Add To Bill'
//                               )}
//                             </Button>
//                           </td>
//                           <td style={{ width: '100%' }}>
//                             <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete">
//                               <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem', marginTop: '1px' }} />
//                             </IconButton>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>

//                 <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//                   <DialogContent>
//                     Are you sure you want to delete this draft bill?
//                   </DialogContent>
//                   <DialogActions>
//                     <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
//                     <Button onClick={confirmDeleteDraftBill} color="secondary">Delete</Button>
//                   </DialogActions>
//                 </Dialog>
//               </Box>
//             </MuiGrid>
//           </MuiGrid>
//         </Box>
//       ) : (
//         'No data found'
//       )}

//       <Box display="flex" justifyContent="flex-end">
//         <Pagination
//           count={Math.ceil(filteredDataCount / limit) || 1}
//           page={page}
//           color="primary"
//           onChange={handlePageChange}
//           sx={{
//             '& .MuiPaginationItem-root': {
//               borderRadius: '4px',
//             },
//             '& .Mui-selected': {
//               backgroundColor: '#6174DD',
//               color: '#fff',
//               '&:hover': {
//                 backgroundColor: '#4a5bc7',
//               },
//             },
//           }}
//         />
//       </Box>

//       <DateRangeInputs
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         onDateRangeSelected={handleDateRangeSelected}
//         selectedEndDate={endDate}
//         selectedStartDate={startDate}
//       />
//     </>
//   );
// };

// export default AllDraftBills;

import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Grid as MuiGrid,
  Pagination,
  Button,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import { useNavigate } from 'react-router';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
import BigFilter from 'src/components/inputs/BigFilter';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { MdDelete } from "react-icons/md";

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const AllDraftBills = () => {
  const [draftBilldata, setDraftBillData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [loadingBillId, setLoadingBillId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [search, setSearch] = useState('');
  const [genderBy, setGenderBy] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [clear, setClear] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [filteredDataCount, setFilteredDataCount] = useState(0);

  const { activeBranchId, fetchDraftBill, fetchSingleBill, setShowMessage, branchData, deleteDraftBill } = useMain();
  const navigate = useNavigate();

  const filterGenderWise = [
    { value: 'Female', label: 'Female' },
    { value: 'Male', label: 'Male' },
  ];

  const handleRowClick = async (billData) => {
    if (billData && billData._id) {
      try {
        setLoadingBillId(billData._id);
        const queryParams = `?branchId=${activeBranchId}&billId=${billData._id}&draftBillId=${billData?.draftBillId}`;
        const res = await fetchSingleBill(queryParams);
        // await console.log('Single draft Bill', {
        //   singleBill: res
        // }) // this res contain the gst fields for product
        // return
        if (res?.statusCode === 200 || res?.status === 'success') {
          const singleBill = res?.data || [];
          navigate('/addbilling', { state: { draftBill: singleBill } });
        } else {
          console.error('Failed to fetch single bill data');
        }
      } catch (error) {
        console.error('Error fetching single draft bill:', error);
      } finally {
        setLoadingBillId(null);
      }
    } else {
      console.error('Invalid bill data:', billData);
    }
  };

  const getDraftBillsData = async (queryParams = '') => {
    try {
      setShowLoader(true);
      const params = queryParams || '?page=1';
      const res = await fetchDraftBill(activeBranchId, params);

      if (res?.statusCode === 200 || res?.status === 'success') {
        setDraftBillData(res?.data || []);
        if (!queryParams.includes('startDate') && !queryParams.includes('endDate')) {
          setFilteredDataCount(res?.data?.length || 0);
        }
      } else {
        setDraftBillData([]);
      }
    } catch (error) {
      setDraftBillData([]);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      getDraftBillsData();
    }
  }, [activeBranchId]);

  useEffect(() => {
    applyFilters(draftBilldata, limit, genderBy, page, search, startDate, endDate);
  }, [draftBilldata, limit, genderBy, page, search, startDate, endDate]);

  const applyFilters = (data, limit, gender, page, search, startDate, endDate) => {
    let filteredData = [...data];

    filteredData = filteredData.filter((item) => {
      let isGenderMatch = true;
      let isNameMatch = true;

      if (gender.length) {
        isGenderMatch = genderBy.includes(item.gender);
      }

      const searchTerm = (search || '').trim().toLowerCase();

      if (searchTerm) {
        isNameMatch =
          (item.clientName || '').toLowerCase().includes(searchTerm) ||
          String(item.clientNumber || '').includes(searchTerm);
      }

      if (startDate && endDate) {
        const itemDate = new Date(item.dateOfBilling);
        const start = new Date(startDate);
        const end = new Date(endDate);
        isNameMatch = isNameMatch && itemDate >= start && itemDate <= end;
      }

      return isGenderMatch && isNameMatch;
    });

    setFilteredDataCount(filteredData.length);

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    setFilterData(paginatedData);
  };

  const handleDateRangeSelected = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setIsModalOpen(false);
    const queryParams = `?page=${page}${genderBy ? `&gender=${genderBy}` : ''}${search.trim() ? `&search=${search.trim()}` : ''
      }${start ? `&startDate=${start}` : ''}${end ? `&endDate=${end}` : ''}`;
    getDraftBillsData(queryParams);
    setClear(true);
  };

  const handleFilterChange = (selectedValues) => {
    setGenderBy(selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val)));
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handlePageChange = (e, value) => {
    setPage(value);
  };

  const confirmDeleteDraftBill = async () => {
    setShowLoader(true);
    try {
      const res = await deleteDraftBill(deleteId, activeBranchId);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Draft bill deleted successfully',
          messageType: 'success',
        });
        setDraftBillData(draftBilldata?.filter((d) => d?._id !== deleteId));
        await getDraftBillsData();
      } else {
        setShowMessage({
          message: res.message || 'Draft bill not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
      setShowLoader(false);
    }
  };

  const handleDeleteField = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };
  // Grid layout for the draft bills table (overrides flex-based .table-thead/.table-tbody CSS)
const draftGridTemplate = 'minmax(95px, 100px) 200px 130px 40px 90px 130px 90px';
  const draftGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: draftGridTemplate,
    alignItems: 'center',
    columnGap: '10px',
  };

  // Remove only leading spaces while typing (spaces between words still work)
    const handleSearchChange = (e) => {
      setSearch(e.target.value.trimStart());
      setPage(1);
    };

    // Runs when the user pastes into the search box
    const handleSearchPaste = (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData('text').trim();

      // If it looks like a phone number, clean it (remove spaces, dashes, brackets, +91)
      const isPhoneLike = /^[+\d\s\-()]+$/.test(pasted);
      const cleaned = isPhoneLike
        ? pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '')
        : pasted;

      setSearch(cleaned);
      setPage(1);
    };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '1.7rem' }}>
        {/* Left Side: Show per page */}
        <div>
          <InputLabel>Show per page</InputLabel>
          <Select
            style={{
              borderRadius: '7px',
              border: '0.5px solid #6174DD',
              padding: '4px 12px',
              background: '#FFF',
              height: '40px',
              width: '100%',
            }}
            value={limit}
            onChange={handleLimitChange}
          >
            {[10, 20, 50].map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
             <MenuItem value={1000000}>All</MenuItem>
          </Select>
        </div>

        {/* Right Side: Search and Filter with 0.8rem gap (Search first, then Filter) */}
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.8rem' }}>
          {/* Search */}
          <div style={{ width: '170px' }} onClick={() => document.getElementById('search-input').focus()}>
            <InputLabel>Search</InputLabel>
            <div className="search-input" style={{ display: 'flex', alignItems: 'center', position: 'relative', zIndex: 10, width: '100%', boxSizing: 'border-box' }}>
              <img src={SearchImg} alt="search icon" style={{ marginRight: '8px' }} />
              <input
                id="search-input"
                type="text"
                placeholder="Search Clients..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onPaste={handleSearchPaste}
                style={{ border: 'none', outline: 'none', flex: 1 }}
              />
              {search && (
                <IconButton
                  onClick={() => {
                    setSearch('');
                    setClear(false);
                  }}
                  style={{ padding: 1 }}
                >
                  <ClearIcon style={{
                    color: '#000',
                    marginRight: '-0.2rem',
                    marginTop: '0.1rem',
                    fontSize: '1.1rem'
                  }} />
                </IconButton>
              )}
            </div>
          </div>

          {/* Filter with Date Range */}
          <div>
            <BigFilter
              options={[
                { title: 'Gender', items: filterGenderWise }
              ]}
              value={[...genderBy]}
              onChange={handleFilterChange}
              showDateRange={true}
              onDateRangeSelected={handleDateRangeSelected}
              selectedStartDate={startDate}
              selectedEndDate={endDate}
              placeholder="Filters"
            />
          </div>
        </div>
      </div>

      {showLoader ? (
        <ShowLoader />
      ) : filterData.length > 0 ? (
        <Box>
          <MuiGrid container spacing={3}>
            <MuiGrid item xs={12}>
              <Box sx={{ overflow: 'auto', width: '100%' }}>
                <table className="table-container mt-3" style={{ width: '100%' }}>
                  <thead className="table-thead">
                   <tr style={draftGridRowStyle}>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>Date of Bill</th>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>Client Name</th>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Contact</th>
                      <th></th>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Gender</th>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Add</th>
                      <th style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody className="table-tbody">
                    {filterData.map((item) => {
                      const originalDate = item?.dateOfBilling;

                      let formattedBillDate = '';
                      if (originalDate) {
                        const [year, month, day] = originalDate.split('-');
                        formattedBillDate = `${day}-${month}-${year}`;
                      }

                    return (
                        <tr key={item._id} style={draftGridRowStyle}>
                          <td style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{formattedBillDate}</td>
                          <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}>{item?.clientName}</td>
                          <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' }}>
                            {maskData(item?.clientNumber, branchData?.isMasked)}
                          </td>
                          <td></td>
                          <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' }}>{item?.gender}</td>
                          <td style={{ textAlign: 'center' }}>
                            <Button
                              style={{
                                backgroundColor: '#5d87ff',
                                color: 'white',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                width: '120px',
                                height: '40px',
                                '&:hover': {
                                  backgroundColor: '#6174DD',
                                },
                              }}
                              onClick={() => handleRowClick(item)}
                            >
                              {loadingBillId === item._id ? (
                                <CircularProgress size={24} style={{ color: '#03C4A9' }} />
                              ) : (
                                'Add To Bill'
                              )}
                            </Button>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete">
                              <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                  <DialogContent>
                    Are you sure you want to delete this draft bill?
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
                    <Button onClick={confirmDeleteDraftBill} color="secondary">Delete</Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </MuiGrid>
          </MuiGrid>
        </Box>
      ) : (
        'No data found'
      )}

      <Box display="flex" justifyContent="flex-end">
        <Pagination
          count={Math.ceil(filteredDataCount / limit) || 1}
          page={page}
          color="primary"
          onChange={handlePageChange}
        // sx={{
        //   '& .MuiPaginationItem-root': {
        //     borderRadius: '4px',
        //   },
        //   '& .Mui-selected': {
        //     backgroundColor: '#6174DD',
        //     color: '#fff',
        //     '&:hover': {
        //       backgroundColor: '#4a5bc7',
        //     },
        //   },
        // }}
        />
      </Box>

      <DateRangeInputs
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onDateRangeSelected={handleDateRangeSelected}
        selectedEndDate={endDate}
        selectedStartDate={startDate}
      />
    </>
  );
};

export default AllDraftBills;

